import React, { Fragment } from 'react';

import UniversalInput from '@lib/wrappers/UniversalInput';

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';
import { omit } from '@utils/miscellaneous/objectHelpers';


const NamesOnDocumentInputs = props => {

    const {
        firstName,
        middleName,
        lastName,
        suffix,
        currentData,
        ...restProps
    } = props;

    const cleanedRestProps = omit(restProps, 'children');

    return (
        <Fragment>
            <UniversalInput
                label={{
                    text: 'ssap.input.label.first_name',
                    isLabelRequired: true
                }}
                inputData={{
                    inputClasses: [],
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'firstName',
                    helperClasses: [],
                    value: firstName,
                    placeholder: 'ssap.input.placeholder.first_name',
                    validationType: VALIDATION_TYPES.NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.FIRST_NAME,
                    currentData: currentData,
                    fields: ['citizenshipImmigrationStatus', 'citizenshipDocument', 'nameOnDocument']
                }}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.middle_name',
                    isLabelRequired: false
                }}
                inputData={{
                    isInputRequired: false,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'middleName',
                    helperClasses: [],
                    value: middleName,
                    placeholder: 'ssap.input.placeholder.middle_name',
                    validationType: VALIDATION_TYPES.MIDDLE_NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.MIDDLE_NAME,
                    currentData: currentData,
                    fields: ['citizenshipImmigrationStatus', 'citizenshipDocument', 'nameOnDocument']
                }}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.last_name',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'lastName',
                    helperClasses: [],
                    value: lastName,
                    placeholder: 'ssap.input.placeholder.last_name',
                    validationType: VALIDATION_TYPES.NAME,
                    validationErrorMessage: VALIDATION_ERROR_MESSAGES.LAST_NAME,
                    currentData: currentData,
                    fields: ['citizenshipImmigrationStatus', 'citizenshipDocument', 'nameOnDocument']
                }}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.suffix',
                    isLabelRequired: false
                }}
                inputData={{
                    isInputRequired: false,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'suffix',
                    value: suffix,
                    options: DROPDOWN_OPTIONS.SUFFIX,
                    currentData: currentData,
                    fields: ['citizenshipImmigrationStatus', 'citizenshipDocument', 'nameOnDocument']
                }}
                {...cleanedRestProps}
            />
        </Fragment>
    );
};

export default NamesOnDocumentInputs;
